import React from "react";
import ReactDOM from "react-dom/client";
// import 'react-data-grid/lib/styles.css';
import "./index.css";
import "./Styles/react-select.css";
import "tw-elements";
import App from "./App";
import { store } from "./store";
import { Provider } from "react-redux";
import { AppErrorBoundary } from "Common/ErrorBoundaries";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AppErrorBoundary>
    <Provider store={store}>
      <App />
    </Provider>
  </AppErrorBoundary>
);
